export default __webpack_public_path__ + "static/media/clock.f2b8443a.svg";